import React, { useRef, useState } from "react";
import "./ProductListHeader.css";
import ProductListButton from "../../Button/ProductListButton";

const ProductListHeader = ({
  navigateToAdmin,
  createPath,
  handleCreate,
  handleDeleteSelected,
  handleDownload,
  handleExcelUpload,
  uploading,
  hasSelectedRows,
  showDelete,
  showUpload,
  showDownload,
  title,
  totalEntries,
}) => {
  const fileInputRef = useRef(null);
  const [isExporting, setIsExporting] = useState(false);

  const triggerFileSelect = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleExportClick = async () => {
    setIsExporting(true);
    try {
      await handleDownload(); // in case handleDownload returns a Promise
    } catch (err) {
      console.error("Export failed:", err);
    } finally {
      setTimeout(() => setIsExporting(false), 1500); // fallback delay
    }
  };

  return (
    <div className="header-container">
      <div className="header-action-row">
        {/* 🔹 LEFT: Text */}
        <div className="header-search-wrapper">
          <div className="header-title">{title}</div>
          <div className="header-total-entries">Total Entries: {totalEntries ?? "Loading..."}</div>
        </div>

        {/* 🔹 RIGHT: Buttons */}
        <div
          className="header-action-buttons"
          style={{ display: "flex", gap: "10px", alignItems: "center" }}
        >
          {showDownload && (
            <ProductListButton
              label={isExporting ? "Exporting Excel..." : "Export Excel"}
              icon={
                isExporting ? "fas fa-spinner fa-spin" : "fas fa-file-download"
              }
              onClick={handleExportClick}
              disabled={isExporting}
            />
          )}

          {showUpload && (
            <>
              <input
                type="file"
                accept=".xlsx, .xls"
                ref={fileInputRef}
                onChange={handleExcelUpload}
                style={{ display: "none" }}
                disabled={uploading}
              />
              <ProductListButton
                label={uploading ? "Importing Excel..." : "Import Excel"}
                icon={
                  uploading ? "fas fa-spinner fa-spin" : "fas fa-file-upload"
                }
                onClick={triggerFileSelect}
                disabled={uploading}
              />
            </>
          )}

          {createPath && (
            <ProductListButton
              label="Create Inventory"
              icon="fas fa-plus"
              onClick={handleCreate}
              color="var(--color-primary)"
              outline={true}
            />
          )}

          {showDelete && hasSelectedRows && (
            <ProductListButton
              label="Delete Inventory"
              icon="fas fa-trash"
              onClick={handleDeleteSelected}
              color="#c0392b"
              outline={true}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default ProductListHeader;
